import { ReactNode } from 'react'

import { Feature } from '@wwt/entities/search-response'

import { cn } from '@/shared/lib/cn'

import { FeatureListElements } from './FeatureListElements.tsx'

interface FeatureListWithOfferConfigurationProps {
	features?: Feature[]
	classNames?: {
		base?: string
		content?: string
	}
	children?: ReactNode

	isDisabledOfferConfiguration?: boolean

	/**
	 * Callback which will be called when need open offer configuration
	 */
	onShowOfferConfiguration: (selectedFeature?: string) => void
}

export const FeatureListWithOfferConfiguration = ({
	features = [],
	classNames,
	children,
	isDisabledOfferConfiguration = false,
	onShowOfferConfiguration
}: FeatureListWithOfferConfigurationProps) => {
	return (
		<div
			className={cn(
				'grid max-w-full grid-cols-[1fr] gap-x-10 gap-y-2 md:grid-cols-[repeat(2,18.5rem)] md:gap-y-3 xl:grid-cols-[repeat(3,25.5rem)]',
				classNames?.base
			)}
		>
			{children}

			<FeatureListElements
				classNames={{ base: classNames?.content }}
				features={features}
				onClick={onShowOfferConfiguration}
				forceIsClickable={isDisabledOfferConfiguration ? false : undefined}
			/>
		</div>
	)
}
